<template>
  <v-col>
    <v-card v-if="items.length > 0">
      <v-toolbar v-show="label || $attrs.site_title" :color="color" dark>
        <v-toolbar-title>{{ label || $attrs.site_title }}</v-toolbar-title>
      </v-toolbar>
      <v-list :two-lines="twoLine" :three-line="threeLine">
        <v-list-item v-if="withSites">
          <v-list-item-content>
            <SiteSelect
              :site="site"
              @site-selected="siteSelected"
              style="width: 100%; height: 50px"
            ></SiteSelect>
          </v-list-item-content>
        </v-list-item>

        <draggable v-if="sortable" v-model="items_" @change="sortNeedUpdate">
          <transition-group
            name="slide-x-transition"
            tag="div"
            role="list"
            class="v-list v-list-two-line"
          >
            <v-list-item
              v-for="(item, i) in items_"
              :key="i + item"
              :to="{ name: editItem, params: { id: item.id }, force: true }"
              @click="onItemClick(item)"
            >
              <v-list-item-avatar v-if="avatarUrl">
                <v-img :src="getAvatar(item)"></v-img>
              </v-list-item-avatar>
              <v-list-item-content style="cursor: pointer">
                <v-list-item-title v-html="title(item)"></v-list-item-title>
                <v-list-item-subtitle
                  v-if="description(item)"
                  v-html="description(item)"
                ></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action-text>
                <slot name="info" v-bind:item="item"></slot>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn icon tag="span" v-on="on">
                      <v-icon
                        color="red"
                        @click.prevent="removeDialog(item.id, title(item), description(item))"
                      >
                        mdi-close
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>удалить запись</span>
                </v-tooltip>
              </v-list-item-action-text>
            </v-list-item>
            <!--</template>-->
          </transition-group>
        </draggable>
        <transition-group
          v-else
          name="slide-x-transition"
          tag="div"
          role="list"
          class="v-list v-list-two-line"
        >
          <v-list-item
            v-for="(item, i) in items_"
            :key="i + item"
            :to="{ name: editItem, params: { id: item.id } }"
            @click="onItemClick(item)"
          >
            <v-list-item-avatar v-if="avatarUrl">
              <v-img :src="getAvatar(item)"></v-img>
            </v-list-item-avatar>
            <v-list-item-content style="cursor: pointer">
              <slot name="prepend" :item="item"></slot>
              <v-list-item-title v-html="title(item)"></v-list-item-title>
              <v-list-item-subtitle
                v-if="description(item)"
                v-html="description(item)"
              ></v-list-item-subtitle>
              <slot name="append" :item="item"></slot>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text>
                <slot name="info" v-bind:item="item"></slot>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn icon tag="span" v-on="on">
                      <v-icon
                        color="red"
                        @click.prevent="removeDialog(item.id, title(item), description(item))"
                      >
                        mdi-close
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>удалить запись</span>
                </v-tooltip>
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
          <!--</template>-->
        </transition-group>
      </v-list>
    </v-card>
    <v-row v-else align-content="center">
      <v-progress-linear></v-progress-linear>
    </v-row>
    <v-btn
      v-show="createItem"
      dark
      absolute
      right
      top
      fab
      color="secondary"
      style="top: 30px"
      :to="{ name: createItem }"
    >
      <v-icon dark>add</v-icon>
    </v-btn>
    <DeleteDialog
      :title="deleteTitle"
      :description="deleteDescription"
      :active="reallyDialog"
      @remove="remove(deleteId)"
      @cancel="cancelRemove"
    >
    </DeleteDialog>
  </v-col>
</template>

<script>
import SiteSelect from '@/components/SiteSelect'
import draggable from 'vuedraggable'
import DeleteDialog from '@/components/DeleteDialog'

export default {
  name: 'ListView',
  components: { SiteSelect, draggable, DeleteDialog },
  props: {
    label: { type: String, default: '' },
    createItem: { type: String, default: '' },
    editItem: { type: String, default: '' },
    avatarUrl: { type: String, default: '' },
    sortable: { type: Boolean, default: true },
    items: {
      type: Array,
      default: function () {
        return Array()
      },
    },
    twoLine: { type: Boolean, default: true },
    threeLine: { type: Boolean, default: false },
    site: { type: String, default: '' },
    itemsName: { type: String, default: '', required: true },
    withSites: { type: Boolean, default: true },
    descriptionField: { type: String, default: 'description' },
    titleField: { type: String, default: 'title' },
    color: { type: String, default: 'secondary' },
  },
  data() {
    return {
      reallyDialog: false,
      items_: Array.from(this.items || []),
      deleteId: null,
      deleteTitle: '',
      deleteDescription: '',
      loading: false,
    }
  },
  watch: {
    items(e) {
      this.items_ = e
    },
  },
  methods: {
    onItemClick(item) {
      this.$emit('item-click', item)
    },
    title(m) {
      let fields = this.titleField.split('|')
      if (fields.length > 1) {
        for (let i = 0; i < fields.length; i++) {
          const val = m[fields[i]]
          if (val) {
            return val
          }
        }
      } else {
        return m[fields[0]] || m.title
      }
    },
    description(m) {
      let fields = this.descriptionField.split('|')
      if (fields.length > 1) {
        let val = m[fields[0]]
        for (let i = 1; i < fields.length; i++) {
          val = val[fields[i]]
        }
        if (val) {
          return val
        }
      } else {
        return m[fields[0]] || m.description
      }
    },
    getAvatar(el) {
      if (!this.avatarUrl) {
        return ''
      }
      let item = { ...el }
      this.avatarUrl.split('.').forEach((x) => {
        item = !item[x] ? '' : item[x]
      })

      return item
    },
    siteSelected(e) {
      this.$emit('site-selected', e)
    },
    removeDialog(id, title, desc) {
      this.deleteId = id
      this.deleteTitle = title
      this.deleteDescription = desc
      this.reallyDialog = true
    },
    cancelRemove() {
      this.deleteId = null
      this.deleteTitle = ''
      this.deleteDescription = ''
      this.reallyDialog = false
    },
    remove(id) {
      this.loading = true
      this.axios({
        url: `/v1/${this.itemsName}/${id}`,
        method: 'delete',
      })
        .then(() => {
          this.showSnackbar('Удалено! А так же, кто это сделал - записано, 8)', 'green')
          this.$emit('remove-item', id)
        })
        .catch((err) => {
          this.$log.error('remove err', err, err.response)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
        .finally(() => {
          this.deleteId = null
          this.deleteTitle = ''
          this.deleteDescription = ''
          this.reallyDialog = false
          this.loading = false
        })
    },
    updateSort(id, sort) {
      this.loading = true
      this.axios({
        url: `/v1/${this.itemsName}/${id}/sort`,
        method: 'post',
        data: { sort: sort },
      })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
        .finally(() => {
          this.loading = false
        })
    },
    sortNeedUpdate(e) {
      const moved = e.moved
      this.$log.debug(e, 'sort')
      if (moved) {
        const index = moved.newIndex
        const item = moved.element
        this.updateSort(item.id, index)
      }
    },
    itemClick(e) {
      this.$emit('item-click', e)
      if (this.editItem) {
        this.$router.push({ name: this.editItem, params: { id: e.id }, force: true })
      }
    },
  },
}
</script>
